import { AppType } from 'src/lib/fliko/enums/appName';

export class ToStringHelper {
  static appNameKey(app: AppType | null): string {
    return app ? `appName.${app}` : '';
  }

  static appName(app: AppType | null, translate: (key: string) => string): string {
    const key = this.appNameKey(app);
    return key ? translate(key) : '';
  }
}
